{
  "name": "pokemon-rogue-battle",
  "private": true,
  "version": "1.12.1.0",
  "type": "module",
  "scripts": {
    "lint": "biome check --diagnostic-level=error",
    "lint:fix": "biome check --write --diagnostic-level=error",
    "start:prod": "vite --mode production",
    "start:beta": "vite --mode beta",
    "start:dev": "vite --mode development",
    "start:podman": "vite --mode development --host 0.0.0.0 --port $PORT",
    "build": "vite build",
    "build:beta": "vite build --mode beta",
    "build:dev": "vite build --mode development",
    "build:app": "vite build --mode app",
    "preview": "vite preview",
    "test": "vitest run",
    "test:profile": "vite-node scripts/profiling/profiling.ts",
    "test:cov": "vitest run --silent='passed-only' --coverage",
    "test:watch": "vitest watch --silent='passed-only'",
    "test:silent": "vitest run --silent='passed-only'",
    "test:merge-reports": "MERGE_REPORTS=1 vitest run --merge-reports=test-results --silent='passed-only' --configLoader runner",
    "test:create": "vite-node scripts/create-test/create-test.ts",
    "decrypt-save": "vite-node scripts/decrypt-save.ts",
    "eggMoves:parse": "vite-node scripts/parse-egg-moves/main.ts",
    "scrape-trainers": "vite-node scripts/scrape-trainer-names/main.ts",
    "dailySeed:create": "vite-node scripts/daily-seed/main.ts",
    "changelog": "node .github/scripts/changelog-reader/main.mts",
    "typecheck": "tsc",
    "typecheck:main": "tsc -p scripts/tsconfig.json",
    "typecheck:github": "tsc -p .github/scripts/tsconfig.json",
    "typecheck:js": "tsc -p jsconfig.json",
    "biome": "biome check --write --changed --no-errors-on-unmatched --diagnostic-level=error",
    "biome:staged": "biome check --write --staged --no-errors-on-unmatched --diagnostic-level=error",
    "biome:all": "biome check --write --no-errors-on-unmatched --diagnostic-level=error",
    "biome:ci": "biome ci --diagnostic-level=error --reporter=github --reporter=default --no-errors-on-unmatched",
    "typedoc": "typedoc",
    "depcruise": "depcruise src test plugins/phaser plugins/vite",
    "postinstall": "lefthook install; git config --local fetch.recurseSubmodules true; git config --local blame.ignoreRevsFile .git-blame-ignore-revs",
    "update-locales": "pnpm update-submodules locales",
    "update-locales:remote": "pnpm update-submodules:remote locales",
    "update-assets": "pnpm update-submodules assets",
    "update-assets:remote": "pnpm update-submodules:remote assets",
    "update-submodules": "git submodule update --progress --init --recursive --force --depth 1",
    "update-submodules:remote": "pnpm update-submodules --remote",
    "sample-movesets": "vite-node scripts/gen-moveset/gen-moveset-driver.ts",
    "species-data:export": "vite-node scripts/species-data-exporter/main.ts"
  },
  "dependencies": {
    "@material/material-color-utilities": "^0.4.0",
    "ajv": "^8.20.0",
    "core-js": "^3.50.0",
    "crypto-js": "^4.2.0",
    "i18next": "^26.4.1",
    "i18next-browser-languagedetector": "^8.2.1",
    "i18next-http-backend": "^4.0.2",
    "i18next-korean-postposition-processor": "^1.0.0",
    "jszip": "^3.10.1",
    "phaser": "^3.90.0",
    "phaser3-rex-plugins": "^1.80.20"
  },
  "devDependencies": {
    "@biomejs/biome": "2.5.1",
    "@commander-js/extra-typings": "^15.0.0",
    "@inquirer/prompts": "^8.7.1",
    "@ls-lint/ls-lint": "2.3.1",
    "@types/crypto-js": "^4.2.2",
    "@types/jsdom": "^30.0.0",
    "@types/node": "^24.13.3",
    "@vitest/coverage-v8": "^4.1.11",
    "@vitest/expect": "^4.1.11",
    "@vitest/utils": "^4.1.11",
    "chalk": "^6.0.0",
    "commander": "^15.0.0",
    "dependency-cruiser": "^18.2.0",
    "jsdom": "^30.0.1",
    "lefthook": "^2.1.12",
    "msw": "^2.15.0",
    "phaser3spectorjs": "^0.0.8",
    "type-fest": "^5.9.0",
    "typedoc": "^0.28.20",
    "typedoc-github-theme": "^0.4.0",
    "typedoc-plugin-coverage": "^4.0.3",
    "typedoc-plugin-mdn-links": "^5.1.1",
    "typedoc-plugin-missing-exports": "^4.1.4",
    "typescript": "^6.0.3",
    "unplugin-inline-enum": "0.8.2",
    "vite": "^8.2.2",
    "vite-node": "^6.0.0",
    "vitest": "^4.1.11",
    "vitest-canvas-mock": "^1.1.5"
  },
  "optionalDependencies": {
    "@actions/core": "^3.0.1",
    "@actions/github": "^9.1.1",
    "octokit": "^5.0.5"
  },
  "engines": {
    "node": ">=24.9.0"
  },
  "packageManager": "pnpm@10.34.5"
}
